import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { createScopedInstance } from '@citrite/translate';
import { useFlowWebContext } from '../FlowWebProvider/useFlowWebContext';
import { languages as resources } from '../locales';
import { getComponentDisplayName } from './getComponentDisplayName';
var scopedTranslateCache = {};
export var useTranslate = function useTranslate() {
  var _scopedTranslateCache;
  var flowWebContext = useFlowWebContext();
  var language = flowWebContext.language;
  // @citrite/translate owns the fallback language, but we don't currently pull that into flow-web config
  var languagekey = language !== null && language !== void 0 ? language : 'default';
  (_scopedTranslateCache = scopedTranslateCache[languagekey]) !== null && _scopedTranslateCache !== void 0 ? _scopedTranslateCache : scopedTranslateCache[languagekey] = getTranslationFunction(languagekey);
  return scopedTranslateCache[languagekey];
};
export function withTranslate(Component) {
  function WithTranslateFunction(props) {
    var translate = useTranslate();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      t: translate
    }));
  }
  WithTranslateFunction.displayName = "WithTranslate(".concat(getComponentDisplayName(Component), ")");
  return WithTranslateFunction;
}
function getTranslationFunction(language) {
  var instance = createScopedInstance({
    namespace: 'citrix-ui',
    resources: resources,
    lng: language
  });
  return instance.t;
}